import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Resultado.types';
import { IResultado } from './resultado.lib';
import { Respuesta } from '@/__env/lib/Cursos/Respuestas';

export class Resultado extends IResultado
{

    public static async create( id: number, usuario?: number ): Promise<Resultado>
    {
        let o = new Resultado();
        o.Curso = id;
        if ( usuario )
            o.Usuario = usuario;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/cursos/resultados';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `/cursos/resultados`;
        request.params.curso = this.Curso;

        if ( this.Usuario )
            request.params.usuario = this.Usuario;

        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Resultado>; Error?: boolean; }>
    {

        let a: Array<Resultado> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/cursos/respuestas` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Resultado( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async CargarRespuestas()
    {
        let resp = await Respuesta.find( { curso: this.Curso, usuario: this.Usuario } );
        this.Respuestas.clear();
        for ( let item of resp.Items )
        {
            this.Respuestas.add( item );
        }
    }
}